import { useEffect } from "react";
import { IconArrowRight, IconX } from "@tabler/icons-react";
import { Logo } from "./logo";

export function MobileMenu({ open, onClose, items }) {
  useEffect(() => {
    if (!open) return;

    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, onClose]);

  return (
    <div
      aria-hidden={!open}
      className={`fixed inset-0 z-50 md:hidden ${
        open ? "pointer-events-auto" : "pointer-events-none"
      }`}
    >
      {/* Backdrop */}
      <button
        type="button"
        aria-label="Close menu"
        onClick={onClose}
        tabIndex={open ? 0 : -1}
        className={`absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity duration-200 ${
          open ? "opacity-100" : "opacity-0"
        }`}
      />

      {/* Panel */}
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Mobile navigation"
        className={`absolute inset-x-0 top-0 origin-top border-b border-white/8 bg-bg-elevated transition-all duration-300 ease-out ${
          open ? "translate-y-0 opacity-100" : "-translate-y-2 opacity-0"
        }`}
      >
        <div className="flex h-16 items-center justify-between border-b border-white/6 px-5">
          <Logo />
          <button
            type="button"
            aria-label="Close menu"
            onClick={onClose}
            className="grid h-9 w-9 place-items-center rounded-lg border border-white/8 bg-white/5 text-text transition hover:border-white/15 hover:bg-white/8"
          >
            <IconX size={16} stroke={2} />
          </button>
        </div>

        <nav className="px-3 py-3">
          {items.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={onClose}
              className="block rounded-lg px-3 py-2.5 text-base font-medium text-text-soft transition hover:bg-white/4 hover:text-text"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex flex-col gap-2 border-t border-white/6 p-4">
          <a
            href="https://app.titanskip.com"
            className="inline-flex h-11 items-center justify-center rounded-xl border border-white/8 bg-white/5 px-4 text-sm font-medium text-text transition hover:border-white/15 hover:bg-white/8"
          >
            Sign in
          </a>
          <a
            href="https://app.titanskip.com"
            className="inline-flex h-11 items-center justify-center gap-1.5 rounded-xl bg-main-500 px-4 text-sm font-semibold text-white transition hover:bg-main-400"
          >
            Get started
            <IconArrowRight size={14} stroke={2.2} />
          </a>
        </div>
      </div>
    </div>
  );
}
